import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CTA() {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section className="relative py-16 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/8f4209add535074792ba300d29b1f0d8.jpg"
          alt="株式会社永恒 物件イメージ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#1A1A1A]/75"></div>
      </div>

      <div
        ref={contentRef as React.RefObject<HTMLDivElement>}
        className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 text-center"
        style={{
          opacity: contentVisible ? 1 : 0,
          transform: contentVisible ? 'translateY(0) scale(1)' : 'translateY(40px) scale(0.97)',
          transition: 'opacity 0.9s ease, transform 0.9s ease',
        }}
      >
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-8 h-px bg-[#D4AF37]"></div>
          <span className="text-[#D4AF37] text-xs tracking-[0.3em] font-medium uppercase">Contact Us</span>
          <div className="w-8 h-px bg-[#D4AF37]"></div>
        </div>
        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          理想の暮らしを、<br />
          <span className="text-[#D4AF37]">共に実現しましょう。</span>
        </h2>
        <p className="text-white/70 text-sm md:text-base leading-relaxed mb-10 max-w-xl mx-auto">
          不動産に関するご相談は、株式会社永恒にお任せください。
          専門スタッフが丁寧にご対応いたします。まずはお気軽にご連絡ください。
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="w-full md:w-auto inline-flex items-center justify-center gap-3 bg-[#B8960C] text-white px-10 py-4 text-sm font-medium tracking-widest hover:bg-[#9A7D0A] transition-all cursor-pointer whitespace-nowrap min-h-[44px]"
          >
            無料相談を申し込む
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
          <a
            href="tel:090-6002-2788"
            className="w-full md:w-auto inline-flex items-center justify-center gap-3 border border-white/50 text-white px-10 py-4 text-sm font-medium tracking-widest hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap min-h-[44px]"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            090-6002-2788
          </a>
        </div>
      </div>
    </section>
  );
}